import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByText',
  standalone: false
})
export class FilterByTextPipe implements PipeTransform {
  transform(items: any[], searchText: string, property?: string | string[]): any[] {
    if (!items) return [];
    if (!searchText) return items;

    const search = searchText.toLowerCase().trim();
    if (!search) return items;

    const properties = Array.isArray(property)
      ? property
      : property
        ? property.split(',').map(p => p.trim())
        : null;

    return items.filter((item) => {
      if (!properties) {
        return item?.toString().toLowerCase().includes(search);
      }
      return properties.some((prop) =>
        item?.[prop]?.toString().toLowerCase().includes(search)
      );
    });
  }
}
